<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="创建时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 120px;" v-model="status" clearable>
              <el-option label="未审核" value="0"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核不通过" value="2"></el-option>
              <el-option label="已打款" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-form :inline="true">
          <el-form-item label="合计" style="5%; font-weight: bold;"></el-form-item>
          <el-form-item label="提取金额：">{{ totalAmountCount.amountWant }}</el-form-item>
          <el-form-item label="打款金额：">{{ totalAmountCount.amountPaybill }}</el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 提取记录table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="withdrawlist"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAmountWantStr"
          label="提取金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAmountPaybillStr"
          label="打款金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="stoppayAmountStr"
          label="止付金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPaybillTime"
          label="打款时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="stateStr"
          label="状态"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { queryAgentWithdrawOrder } from '@/api/settle'
export default {
  name: 'ProfitExtractRecord',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        state: ''
      },
      creatTime: [],
      status: '',
      tableLoading: false,
      withdrawlist: [],
      totalAmountCount: {},
      isInstitution: this.$store.getters.roleId === 10,
      customerId: ''
    }
  },
  mounted () {
    this.searchClick()
  },
  beforeDestroy () {},
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.state = this.status || ''
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      if (this.isInstitution) {
        if (this.customerId) {
          this.searchInfo = Object.assign({ agentId: this.customerId }, this.searchInfo, this.paginations)
        } else {
          this.$message({
            type: 'error',
            message: '地址错误，请重试',
            showClose: true
          })
          this.$router.push('/SettleAccounts/Profit/CustomerProfitExtract')
        }
      } else {
        this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      }
      this.getQueryAgentWithdrawOrder()
    },
    /**
     * 获取分润提取记录
     */
    getQueryAgentWithdrawOrder () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      queryAgentWithdrawOrder(params).then(response => {
        this.loading = false
        console.log('queryAgentWithdrawOrder response:', response)
        if (response.error_code === '0') {
          const json = response.data
          this.withdrawlist = json.list
          this.totalAmountCount = {
            amountPaybill: json.amountPaybill,
            amountWant: json.amountWant
          }
          this.paginations.count = json.totalCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
          // this.$message({
          //   message: response.error_msg,
          //   type: 'success'
          // })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    dateChange (value) {
      this.creatTime = value
    }
  },
  computed: {},
  filters: {
    formatFState (value) {
      switch (value) {
        case 0:
          return '初始化状态'
        case 1:
          return '金额冻结成功'
        case 2:
          return '金额冻结失败'
        case 3:
          return '冻结结果未知'
        case 4:
          return '商户打款被冻结'
        case 5:
          return '被拦截<未发起付款>'
        case 6:
          return '打款中'
        case 14:
          return '金额解冻结果未知'
        case 15:
          return '退票成功'
        case 16:
          return '退票失败'
        case 17:
          return '退票结果未知'
        case 18:
          return '打款单被合并'
        case 19:
          return '提交打款失败，允许重新打款'
        case 20:
          return '申请退票'
        case 7:
          return '付款成功'
        case 8:
          return '付款失败'
        case 9:
          return '金额解冻转账成功'
        case 10:
          return '金额解冻转账失败'
        case 11:
          return '金额解冻转账结果未知'
        case 12:
          return '金额解冻成功'
        case 13:
          return '金额解冻失败'
      }
    }
  },
  created () {
    if (JSON.stringify(this.$route.query) !== '{}') {
      const query = this.$route.query
      if (this.customerId !== query.customerId) {
        this.customerId = query.customerId
        localStorage.setItem('profitExtractRecordId', query.customerId)
      }
    } else {
      if (localStorage.getItem('profitExtractRecordId') !== '') {
        this.customerId = localStorage.getItem('profitExtractRecordId')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
</style>
